import ApplicationController from './application_controller'
import $ from 'jquery';
import select2 from 'select2';
import 'select2/dist/css/select2.css';


export default class extends ApplicationController {
  static targets = [ 'contacts' ]
  connect() {
    super.connect()
    $(".select2").select2({
      theme: 'bootstrap4',
    });
    
    $(".select2-customers").on('select2:select', e => {
      console.log("list item selected");
      if (this.hasContactsTarget) {
        this.choose_customer(e)
      }
    })

    $(".select2-events").on('select2:select', e => {
      console.log("list item selected");
      let event = new Event('change', { bubbles: true }) // fire a native event
      this.stimulate("RoomOrder#show", e.target.value)
    });

  }

  choose_customer(e){
    console.log(e.target.value);
    this.stimulate("Events#choose_customer", e.target.value)

  }
  finalizeReflex(element, reflex, noop, reflexId){
    // Reinitialize select2 after morphing
    // Use setTimeout to ensure DOM has been fully updated (critical in production)
    setTimeout(() => {
      const contactSelect = $('#event_contact_ids');
      if (contactSelect.length) {
        // Destroy existing select2 instance if it exists to avoid conflicts
        if (contactSelect.hasClass("select2-hidden-accessible")) {
          contactSelect.select2("destroy");
        }
        // Reinitialize select2
        contactSelect.select2({
          theme: 'bootstrap4',
        });
      }
    }, 50);
  }
}
